<div class="header" [ngClass]="{'tabbed': config.displayMode === 'tabbed'}" (click)="makeActiveViewContainer()">
  @if (config.name) {
    <div class="name">{{config.name}}</div>
  }
  @if (config.displayMode === 'tabbed') {
    <div #tabheader class="tab-header" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="tabDropped($event)">
      @for (tab of tabsOrder; track tab.id) {
        @if (!!viewConfigs[tab.index]) {
          <div cdkDrag cdkDragLockAxis="x" class="tab-item-header tab-item-header-{{tab.index}}" [ngClass]="{'active-in-container': tab.id === activeTab, 'active-view': config.id === activeViewContainer}" (auxclick)="closeView(tab.id)" (click)="activateTab(tab.id)" [attr.data-testing-id]="'workbench-tab-' + tab.index">
            <div class="tab-drag-placeholder" *cdkDragPlaceholder>
              <ng-container *ngTemplateOutlet="tabtemplate"></ng-container>
            </div>
            <div class="tab-drag-preview" *cdkDragPreview></div>
            <ng-container *ngTemplateOutlet="tabtemplate"></ng-container>
            <ng-template #tabtemplate>
              @if (viewConfigs[tab.index].icon && viewConfigs[tab.index].icon.type === 'faIcon') {
                <div class="tab-icon"><fa-icon [icon]="viewConfigs[tab.index].icon.instance"></fa-icon></div>
              }
              <div class="tab-title">{{viewConfigs[tab.index].name}}</div>
              @if (!!viewConfigs[tab.index] && viewStates[tab.id]) {
                <div>
                  @if (viewStates[tab.id]?.viewComponentRef?.instance?.headerTemplate && !viewStates[tab.id]?.viewComponentRef?.instance?.tabHeaderTemplate) {
                    <ng-container [ngTemplateOutlet]="viewStates[tab.id].viewComponentRef.instance.headerTemplate"></ng-container>
                  }
                  @if (viewStates[tab.id]?.viewComponentRef?.instance?.tabHeaderTemplate) {
                    <ng-container [ngTemplateOutlet]="viewStates[tab.id].viewComponentRef.instance.tabHeaderTemplate"></ng-container>
                  }
                </div>
              }
              <div class="tab-close" (click)="closeView(tab.id)"><fa-icon [icon]="faTimes"></fa-icon></div>
            </ng-template>
          </div>
        }
      }
    </div>
  }
  <div class="controls">
    @if (dotMenuModel.length > 0) {
      <fa-icon class="control" (click)="menu.toggle($event)" [icon]="faEllipsisV"></fa-icon>
    }
</div>
<p-tieredMenu #menu [popup]="true" appendTo="body" [model]="dotMenuModel"></p-tieredMenu>
</div>
<div class="views" #scrollView
     [ngClass]="{'scrollable': config.displayMode === 'stacked', 'scrollable-standalone': config.displayMode === 'standalone'}"
     wmtDragDrop [dragEnabled]="config.acceptsFileDrop"
     (filesDropped)="onFilesDropped($event)">
  @if (config.displayMode === 'stacked' || config.displayMode === 'standalone') {
    @for (idx of tabIndices; track idx) {
      <div [ngClass]="{'full-height': config.displayMode === 'standalone'}">
        @if (viewConfigs[idx] && config.displayMode !== 'standalone') {
          <div class="view-header" [id]="'view-header-' + viewConfigs[idx].id">
            <div class="chevron" (click)="toggleView(viewConfigs[idx].id)">
              <fa-icon [icon]="faChevronDown" [ngClass]="{'collapsed': !viewStates[viewConfigs[idx]?.id]?.expanded}"></fa-icon>
            </div>
            <div class="title" (click)="toggleView(viewConfigs[idx].id)" [attr.data-testing-id]="'workbench-toggle-' + viewConfigs[idx]?.name">{{viewConfigs[idx]?.name}}</div>
            <div class="custom-actions">
              @if (!!viewConfigs[idx] && viewStates[viewConfigs[idx]?.id]) {
                <div>
                  @if (viewStates[viewConfigs[idx]?.id]?.viewComponentRef?.instance?.headerTemplate && !viewStates[viewConfigs[idx]?.id]?.viewComponentRef?.instance?.stackHeaderTemplate) {
                    <ng-container [ngTemplateOutlet]="viewStates[viewConfigs[idx].id].viewComponentRef.instance.headerTemplate"></ng-container>
                  }
                  @if (viewStates[viewConfigs[idx]?.id]?.viewComponentRef?.instance?.stackHeaderTemplate) {
                    <ng-container [ngTemplateOutlet]="viewStates[viewConfigs[idx].id].viewComponentRef.instance.headerTemplate"></ng-container>
                  }
                </div>
              }
            </div>
          </div>
        }
        <div class="view-wrapper" [ngClass]="{'full-height':config.displayMode === 'standalone'}">
          <wm-workbench-viewwrapper [ngClass]="{'hidden-stack-item': config.displayMode === 'stacked' && !viewStates[viewConfigs[idx]?.id]?.expanded, 'full-height': config.displayMode === 'standalone'}" [viewConfig]="viewConfigs[idx]" class="view" [id]="'vc-' + config.id + '-' + idx"></wm-workbench-viewwrapper>
        </div>
      </div>
    }
  }
  @if (config.displayMode === 'tabbed') {
    @for (idx of tabIndices; track idx) {
      <div class="view-wrapper" [ngClass]="{'hidden-tab': activeTab !== viewConfigs[idx]?.id, 'scrollable': viewConfigs[idx] && (viewConfigs[idx].styleConfig?.tabbed?.scrollable || viewConfigs[idx].styleConfig?.tabbed?.scrollable === undefined), 'no-margin': viewConfigs[idx]?.styleConfig?.tabbed?.noMargin}">
        <wm-workbench-viewwrapper [scrollable]="!!viewConfigs[idx] && (viewConfigs[idx]?.styleConfig?.tabbed?.scrollable || viewConfigs[idx].styleConfig?.tabbed?.scrollable === undefined)" [viewConfig]="viewConfigs[idx]" class="view" [id]="'vc-' + config.id + '-' + idx"></wm-workbench-viewwrapper>
      </div>
    }
  }
</div>
